export enum AppSettingValueType {
    String = 10,
    Number = 20,
    Bit = 30,
    Dropdown = 40,
    Json = 50,
    Base64Img = 60,
    Color = 70,
    Action = 80,
}
